;(function(w, d) {
  'use strict';

  // ─────────────────────────────────────────────────────────────
  //  AUTO-SETUP CONSTANTS
  // ─────────────────────────────────────────────────────────────
  var BLANK = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

  var EXCLUDE = [
    'googletagmanager.com', 'google-analytics.com',
    'gtag/js', 'GTM-', 'gtag(',
    'fbq(', 'fbevents.js', 'connect.facebook.net',
    'clarity.ms', 'hotjar.com',
    'tiktok.com/i18n/pixel', 'analytics.tiktok.com',
    'snap.licdn.com', 'static.klaviyo.com', 'bat.bing.com',
    'cdn.shopify.com/s/trekkie',
    'cdn.shopify.com/s/files/1/0/shopify'
  ];

  var SCRIPT_CRITICAL = [
    'jquery', 'jQuery',
    'theme.js', 'theme.min.js',
    'vendor.js', 'vendor.min.js',
    'shopify_pay', 'shopify-pay',
    'shopifycloud/payment-sheet',
    'shopifycloud/buy-button',
    'shopifycloud/accelerated-checkout',
    'shopifycloud/checkout',
    'shopifycloud/checkout-web',
    'shopifycloud/portable-wallets',
    'portable-wallets',
    '/checkouts/internal',
    'checkouts/internal',
    'payment-button',
    'dynamic-checkout',
    'accelerated-checkout',
    'checkout-web',
    'web-components',
    'predictive-search',
    'product-form',
    'slick', 'slider', 'swiper', 'splide', 'glide',
    'pay.shopify.com',
    'checkout.js',
    'shopify_pay_utils',
    'cart.js',
    '/cart/',
    'storefront-renderer'
  ];

  var CSS_SKIP = [
    'critical', 'fm-critical',
    'shopify_pay', 'checkout.css', '/checkout/',
    'payment-button', 'dynamic-checkout',
    'portable-wallets',
    'slick', 'slider', 'swiper', 'splide', 'glide'
  ];

  // ─────────────────────────────────────────────────────────────
  //  ENGINE CONFIG
  // ─────────────────────────────────────────────────────────────
  var _href = w.location.href;
  var _skip = (w.Shopify && w.Shopify.designMode)
    || _href.indexOf('/cart')     > -1
    || _href.indexOf('/checkout') > -1;

  var _c = {
    mobile     : w.screen.width <= 768,
    nearMargin : '200px',
    bgMargin   : '120px',
    waitMs     : 350,
    idleMs     : 8000,
    cleanupMs  : 9000,
    analyticsMs: 180,
  };

  var _fired  = false;
  var _queued = false;

  // ─────────────────────────────────────────────────────────────
  //  SHARED HELPERS
  // ─────────────────────────────────────────────────────────────
  var VH = w.innerHeight || d.documentElement.clientHeight || 800;

  // WebP support detection
  var _webp = (function() {
    try { return d.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0; }
    catch(e) { return false; }
  })();

  function matchesAny(str, list) {
    if (!str) return false;
    for (var i = 0; i < list.length; i++) {
      if (str.indexOf(list[i]) > -1) return true;
    }
    return false;
  }

  function isAboveFold(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < VH && rect.bottom > 0;
  }

  function isDataUri(str) {
    return str && str.indexOf('data:') === 0;
  }

  // Shopify CDN URL optimizer — sets responsive width + WebP
  function _shopifyUrl(url, maxW) {
    if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
    url = url.replace(/([?&]width=)\d+/, '$1' + maxW);
    if (_webp && url.indexOf('format=') === -1) {
      url += (url.indexOf('?') > -1 ? '&' : '?') + 'format=webp';
    }
    return url;
  }

  function isTinyPixel(img) {
    var iw = parseInt(img.getAttribute('width')  || '0');
    var ih = parseInt(img.getAttribute('height') || '0');
    return (iw > 0 && iw <= 3) || (ih > 0 && ih <= 3);
  }

  function alreadyLazy(el) {
    return el.hasAttribute('data-src')
        || el.hasAttribute('data-href')
        || el.hasAttribute('data-fm-skip')
        || el.classList.contains('fm-img')
        || el.classList.contains('lazy2')
        || el.classList.contains('lazy3')
        || el.classList.contains('lazyloaded')
        || el.classList.contains('lazyautosizes')
        || el.classList.contains('lazyload')
        || el.getAttribute('loading') === 'lazy';
  }

  // ─────────────────────────────────────────────────────────────
  //  MUTATION OBSERVER — intercepts <script> and <link> early
  //  Runs immediately (before DOMContentLoaded)
  // ─────────────────────────────────────────────────────────────
  function interceptNode(node) {
    if (node.nodeType !== 1) return;

    // Script interception removed — all scripts load natively.
    // Without Liquid pre-processing, deferring scripts here breaks checkout.

    if (node.tagName === 'LINK' && node.getAttribute('rel') === 'stylesheet') {
      var href = node.getAttribute('href') || '';
      if (!href)                              return;
      if (node.hasAttribute('data-href'))     return;
      if (node.hasAttribute('data-fm-skip'))  return;
      if (matchesAny(href, CSS_SKIP))         return;
      if (matchesAny(href, EXCLUDE))          return;
      node.setAttribute('data-href', href);
      node.removeAttribute('href');
      node.removeAttribute('rel');
    }
  }

  if (w.MutationObserver && d.documentElement) {
    var _mo = new MutationObserver(function(records) {
      records.forEach(function(r) {
        r.addedNodes.forEach(interceptNode);
      });
    });
    _mo.observe(d.documentElement, { childList: true, subtree: true });
    d.addEventListener('DOMContentLoaded', function() { _mo.disconnect(); });
  }

  // ─────────────────────────────────────────────────────────────
  //  VIEWPORT WATCHER
  // ─────────────────────────────────────────────────────────────
  function _watcher(fn, margin) {
    if (!('IntersectionObserver' in w)) {
      return { track: fn, drop: function() {} };
    }
    var io = new IntersectionObserver(function(list, self) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].isIntersecting) {
          fn(list[i].target);
          self.unobserve(list[i].target);
        }
      }
    }, { rootMargin: margin });
    return { track: function(el) { io.observe(el); }, drop: function(el) { io.unobserve(el); } };
  }

  // ─────────────────────────────────────────────────────────────
  //  IMAGES
  // ─────────────────────────────────────────────────────────────
  function _showImg(el) {
    var maxW = _c.mobile ? 800 : 1920;
    var src = _c.mobile
      ? (el.getAttribute('data-mobsrc') || el.getAttribute('data-src'))
      : el.getAttribute('data-src');
    var set = el.getAttribute('data-srcset');
    if (src) el.src = _shopifyUrl(src, maxW);
    if (set) el.srcset = set;
    el.classList.remove('fm-img', 'fm-img-near', 'lazy2', 'lazy3');
  }

  var _imgWatch = _watcher(_showImg, _c.nearMargin);

  function _attachImgWatch() {
    d.querySelectorAll(
      'img[data-src].fm-img, img[data-src].fm-img-near, img[data-src].lazy2, img[data-src].lazy3'
    ).forEach(function(el) { _imgWatch.track(el); });
  }

  function _liveImgWatch() {
    if (!w.MutationObserver) return;
    new MutationObserver(function(records) {
      records.forEach(function(r) {
        r.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          var sel = 'img[data-src].fm-img, img[data-src].fm-img-near, img[data-src].lazy2, img[data-src].lazy3';
          if (node.matches && node.matches(sel)) _imgWatch.track(node);
          if (node.querySelectorAll) node.querySelectorAll(sel).forEach(function(el) { _imgWatch.track(el); });
        });
      });
    }).observe(d.body, { childList: true, subtree: true });
  }

  // ─────────────────────────────────────────────────────────────
  //  BACKGROUNDS
  // ─────────────────────────────────────────────────────────────
  function _showBg(el) {
    var rule = _c.mobile
      ? (el.getAttribute('data-mob-bg')    || el.getAttribute('data-mobstyle') ||
         el.getAttribute('data-bg-style')  || el.getAttribute('data-style'))
      : (el.getAttribute('data-bg-style')  || el.getAttribute('data-style'));
    if (rule) el.setAttribute('style', rule);
    el.classList.remove('fm-bg', 'lazybg');
  }

  var _bgWatch = _watcher(_showBg, _c.bgMargin);

  function _attachBgWatch() {
    d.querySelectorAll('.fm-bg, .lazybg').forEach(function(el) { _bgWatch.track(el); });
  }

  // ─────────────────────────────────────────────────────────────
  //  CSS ACTIVATION
  // ─────────────────────────────────────────────────────────────
  function _activateStyles() {
    d.querySelectorAll('link[data-href]').forEach(function(node) {
      var link = d.createElement('link');
      link.rel  = 'stylesheet';
      link.href = node.getAttribute('data-href');
      node.parentNode.insertBefore(link, node);
      node.parentNode.removeChild(node);
    });

    d.querySelectorAll('style[type="fm-defer"], style[type="lazyload2"]').forEach(function(node) {
      var tag = d.createElement('style');
      tag.innerHTML = node.innerHTML;
      node.parentNode.insertBefore(tag, node);
      node.parentNode.removeChild(node);
    });

    d.querySelectorAll('.fm-crit-temp, .cls_css').forEach(function(el) { el.remove(); });
  }

  // ─────────────────────────────────────────────────────────────
  //  MEDIA — iframes (load on gesture)
  // ─────────────────────────────────────────────────────────────
  function _activateMedia() {
    var _iframeWatch = _watcher(function(el) {
      var src = el.getAttribute('data-src');
      if (src) { el.src = src; el.removeAttribute('data-src'); }
    }, _c.nearMargin);

    d.querySelectorAll('iframe[data-src]').forEach(function(el) { _iframeWatch.track(el); });
  }

  // ─────────────────────────────────────────────────────────────
  //  VIDEOS — only after full page load (fm_ready)
  //  Above-fold: load immediately | Below-fold: IntersectionObserver
  // ─────────────────────────────────────────────────────────────
  function _activateVideos() {
    function _loadVideo(v) {
      // Restore video[src]
      var src = v.getAttribute('data-src');
      if (src) { v.src = src; v.removeAttribute('data-src'); }

      // Restore poster
      var poster = v.getAttribute('data-poster');
      if (poster) { v.poster = poster; v.removeAttribute('data-poster'); }

      // Restore <source> tags (Shopify theme pattern)
      v.querySelectorAll('source[data-src]').forEach(function(s) {
        s.src = s.getAttribute('data-src');
        s.removeAttribute('data-src');
      });

      v.load();
      if (v.muted || v.hasAttribute('autoplay')) {
        v.muted = true;
        v.play().catch(function() {});
      }
    }

    var _videoWatch = _watcher(_loadVideo, _c.nearMargin);

    d.querySelectorAll('video').forEach(function(v) {
      var needsLoad = v.hasAttribute('data-src')
                   || v.hasAttribute('data-poster')
                   || !!v.querySelector('source[data-src]');
      if (!needsLoad) return;

      // Above-fold video (e.g. hero): load right after fm_ready, no scroll wait
      if (isAboveFold(v)) {
        _loadVideo(v);
      } else {
        _videoWatch.track(v);
      }
    });
  }

  // ─────────────────────────────────────────────────────────────
  //  SHOPIFY PLATFORM SCRIPTS
  // ─────────────────────────────────────────────────────────────
  function _releasePlatformScripts() {
    // No-op: analytics/boomerang elements were Liquid-generated.
    // Trekkie, BOOMR, and monorail are now handled via EXCLUDE list
    // and load through content_for_header directly.
  }

  // ─────────────────────────────────────────────────────────────
  //  SCRIPT QUEUE
  // ─────────────────────────────────────────────────────────────
  function _processNext() {
    var node = d.querySelector(
      'script[type="fm-defer"], script[type="lazyload2"], script[type="lazyload_int"], script[type="lazyload_ext"]'
    );

    if (!node) { _onAllReady(); return; }

    var tag = d.createElement('script');
    var src = node.getAttribute('data-src');

    Array.prototype.slice.call(node.attributes).forEach(function(a) {
      if      (a.name === 'data-src')  { /* handled below */ }
      else if (a.name === 'data-type') { tag.type = a.value; }
      else if (a.name !== 'type')      { tag.setAttribute(a.name, a.value); }
    });

    if (src) {
      tag.src     = src;
      tag.onload  = _processNext;
      tag.onerror = _processNext;
    } else {
      tag.text = node.innerHTML;
    }

    node.parentNode.insertBefore(tag, node.nextSibling);
    node.parentNode.removeChild(node);

    if (!src) _processNext();
  }

  // ─────────────────────────────────────────────────────────────
  //  ALL SCRIPTS LOADED
  // ─────────────────────────────────────────────────────────────
  function _onAllReady() {
    d.body && d.body.classList.add('fm-ready');

    _activateVideos();

    _broadcast('fm_ready');

    setTimeout(function() { _broadcast('DOMContentLoaded2'); }, 5000);

    setTimeout(function() {
      d.querySelectorAll('.fm-crit, .critical2').forEach(function(el) { el.remove(); });
    }, _c.cleanupMs);

    setInterval(function() {
      d.querySelectorAll('img[data-src].fm-img, img[data-src].fm-img-near, img[data-src].lazy2, img[data-src].lazy3')
        .forEach(_showImg);
      d.querySelectorAll('iframe[data-src]').forEach(function(el) {
        el.src = el.getAttribute('data-src');
        el.removeAttribute('data-src');
      });
    }, 3000);
  }

  function _broadcast(name) {
    try {
      var e = d.createEvent('Event');
      e.initEvent(name, true, true);
      d.dispatchEvent(e);
    } catch (_) {}
  }

  // ─────────────────────────────────────────────────────────────
  //  GESTURE TRIGGER
  // ─────────────────────────────────────────────────────────────
  var _LISTEN = ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'];

  function _onGesture() {
    if (_fired) return;
    _fired = true;
    _LISTEN.forEach(function(t) { w.removeEventListener(t, _onGesture); });

    _activateStyles();
    _activateMedia();
    _releasePlatformScripts();

    setTimeout(function() {
      if (!_queued) { _queued = true; _processNext(); }
    }, _c.waitMs);
  }

  // ─────────────────────────────────────────────────────────────
  //  BYPASS — cart / checkout / design mode
  // ─────────────────────────────────────────────────────────────
  function _bypass() {
    d.querySelectorAll(
      'img[data-src].fm-img, img[data-src].fm-img-near, img[data-src].lazy2, img[data-src].lazy3'
    ).forEach(_showImg);
    d.querySelectorAll('.fm-bg, .lazybg').forEach(_showBg);
    _activateStyles();
    _activateMedia();
    _activateVideos();
    _queued = true;
    _processNext();
  }

  // ─────────────────────────────────────────────────────────────
  //  AUTO-SETUP DOM SCAN (DOMContentLoaded)
  // ─────────────────────────────────────────────────────────────
  function _setupImages() {
    d.querySelectorAll('img').forEach(function(img) {
      var src = img.getAttribute('src') || '';
      if (alreadyLazy(img))           return;
      if (!src || isDataUri(src))     return;
      if (src.indexOf('.svg') > -1)   return;
      if (isTinyPixel(img))           return;

      if (isAboveFold(img)) {
        // LCP candidate — boost priority, never lazy
        img.setAttribute('fetchpriority', 'high');
        img.removeAttribute('loading');
        var maxW = _c.mobile ? 800 : 1920;
        var optimized = _shopifyUrl(src, maxW);
        if (optimized !== src) img.src = optimized;
        return;
      }

      img.setAttribute('data-src', src);
      var ss = img.getAttribute('srcset');
      if (ss) { img.setAttribute('data-srcset', ss); img.removeAttribute('srcset'); }
      img.src = BLANK;
      img.classList.add('fm-img');
    });
  }

  function _setupBackgrounds() {
    d.querySelectorAll('[style*="background-image"]').forEach(function(el) {
      if (el.hasAttribute('data-fm-skip'))  return;
      if (el.hasAttribute('data-bg-style')) return;
      if (el.classList.contains('fm-bg') || el.classList.contains('lazybg')) return;
      var style = el.getAttribute('style');
      if (style.indexOf('data:') > -1) return;
      if (isAboveFold(el))             return;
      el.setAttribute('data-bg-style', style);
      var stripped = style.replace(/background-image\s*:[^;]+;?/gi, '').trim();
      stripped ? el.setAttribute('style', stripped) : el.removeAttribute('style');
      el.classList.add('fm-bg');
    });
  }

  function _setupIframes() {
    d.querySelectorAll('iframe').forEach(function(el) {
      var src = el.getAttribute('src') || '';
      if (!src || el.hasAttribute('data-src') || el.hasAttribute('data-fm-skip')) return;
      if (matchesAny(src, EXCLUDE)) return;
      if (isAboveFold(el))          return;
      // Skip hidden iframes — payment gateways (Shop Pay, PayPal, etc.) use
      // zero-size hidden iframes that must stay loaded for checkout to work.
      // IntersectionObserver never fires on hidden elements so they'd be stuck src-less.
      if (el.offsetWidth === 0 || el.offsetHeight === 0) return;
      el.setAttribute('data-src', src);
      el.removeAttribute('src');
    });
  }

  function _setupVideos() {
    d.querySelectorAll('video').forEach(function(v) {
      if (v.hasAttribute('data-fm-skip')) return;

      // Always block browser from auto-downloading
      v.setAttribute('preload', 'none');

      // Handle video[src] directly
      var src = v.getAttribute('src') || '';
      if (src && !isDataUri(src) && !v.hasAttribute('data-src')) {
        v.setAttribute('data-src', src);
        v.removeAttribute('src');
      }

      // Handle poster
      var poster = v.getAttribute('poster') || '';
      if (poster && !isDataUri(poster) && !v.hasAttribute('data-poster')) {
        v.setAttribute('data-poster', poster);
        v.removeAttribute('poster');
      }

      // Handle <source> tags — most Shopify themes use this pattern
      v.querySelectorAll('source[src]').forEach(function(s) {
        var ssrc = s.getAttribute('src') || '';
        if (!ssrc || isDataUri(ssrc)) return;
        s.setAttribute('data-src', ssrc);
        s.removeAttribute('src');
      });
    });
  }

  function _rescueAnalytics() {
    // Rescue fm-deferred scripts that are analytics/tracking (must not be delayed)
    var sel = 'script[type="fm-defer"],script[type="lazyload2"],script[type="lazyload_int"]';
    d.querySelectorAll(sel).forEach(function(el) {
      var src  = el.getAttribute('data-src') || '';
      var body = el.textContent || '';
      if (!matchesAny(src, EXCLUDE) && !matchesAny(body, EXCLUDE)) return;
      var live = d.createElement('script');
      if (src) { live.src = src; } else { live.text = body; }
      Array.prototype.slice.call(el.attributes).forEach(function(a) {
        if (a.name !== 'type' && a.name !== 'data-src') live.setAttribute(a.name, a.value);
      });
      el.parentNode.insertBefore(live, el);
      el.parentNode.removeChild(el);
    });

    // Rescue async scripts whose src was stripped by Liquid's blanket replace.
    // async scripts are non-blocking so restoring them immediately is safe.
    d.querySelectorAll('script[data-src][async]').forEach(function(el) {
      var src = el.getAttribute('data-src') || '';
      if (!src) return;
      var live = d.createElement('script');
      live.src   = src;
      live.async = true;
      el.parentNode.insertBefore(live, el);
      el.parentNode.removeChild(el);
    });
  }

  // ─────────────────────────────────────────────────────────────
  //  GOOGLE FONTS — async load + font-display:swap + preconnect fix
  // ─────────────────────────────────────────────────────────────
  function _setupFonts() {
    // Ensure preconnects exist for Google Fonts origins
    var _fontOrigins = [
      { href: 'https://fonts.googleapis.com', co: false },
      { href: 'https://fonts.gstatic.com',    co: true  }
    ];
    _fontOrigins.forEach(function(o) {
      if (!d.querySelector('link[rel="preconnect"][href="' + o.href + '"]')) {
        var pc = d.createElement('link');
        pc.rel  = 'preconnect';
        pc.href = o.href;
        if (o.co) pc.crossOrigin = 'anonymous';
        d.head.appendChild(pc);
      }
    });

    // Load Google Fonts immediately but non-blocking (print media trick)
    // Engine's MutationObserver already converted these to link[data-href]
    d.querySelectorAll('link[data-href*="fonts.googleapis.com"]').forEach(function(node) {
      var href = node.getAttribute('data-href') || '';
      // Add display=swap so text stays visible during font load
      if (href.indexOf('display=') === -1) {
        href += (href.indexOf('?') > -1 ? '&' : '?') + 'display=swap';
      }
      var link = d.createElement('link');
      link.rel    = 'stylesheet';
      link.media  = 'print';           // non-blocking trick
      link.href   = href;
      link.onload = function() { this.media = 'all'; this.onload = null; };
      d.head.appendChild(link);
      node.parentNode && node.parentNode.removeChild(node);
    });

    // Preconnect trimming removed — payment gateways need their preconnects.
  }

  // ─────────────────────────────────────────────────────────────
  //  MODULE SCRIPT RESCUE — restores type="module" scripts that
  //  had their src replaced with data-src by Liquid transforms
  // ─────────────────────────────────────────────────────────────
  function _rescueModuleScripts() {
    d.querySelectorAll('script[type="module"][data-src]').forEach(function(node) {
      var src = node.getAttribute('data-src');
      if (!src) return;
      var tag = d.createElement('script');
      tag.type = 'module';
      tag.src  = src;
      Array.prototype.slice.call(node.attributes).forEach(function(a) {
        if (a.name !== 'data-src' && a.name !== 'type' && a.name !== 'src')
          tag.setAttribute(a.name, a.value);
      });
      node.parentNode.replaceChild(tag, node);
    });
  }

  // ─────────────────────────────────────────────────────────────
  //  BOOT
  // ─────────────────────────────────────────────────────────────
  function _boot() {
    // DOM scan first
    _rescueModuleScripts();
    _rescueAnalytics();
    _setupFonts();
    _setupImages();
    _setupBackgrounds();
    _setupIframes();
    _setupVideos();

    if (_skip) { _bypass(); return; }

    _attachImgWatch();
    _attachBgWatch();
    _liveImgWatch();

    _LISTEN.forEach(function(t) { w.addEventListener(t, _onGesture, { passive: true }); });

    setTimeout(_onGesture, _c.idleMs);
  }

  d.readyState === 'loading'
    ? d.addEventListener('DOMContentLoaded', _boot)
    : _boot();

  // ─────────────────────────────────────────────────────────────
  //  PUBLIC DEBUG API
  // ─────────────────────────────────────────────────────────────
  w.FM = {
    v: '1.0',
    cfg: _c,
    status: function() {
      return { mobile: _c.mobile, fired: _fired, queued: _queued };
    }
  };

}(window, document));
